import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["container", "id", "name"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
      ? (_openBlock(), _createElementBlock("br", {
          key: 0,
          container: _ctx.container,
          id: _ctx.getPropertyValue(_ctx.HtmlTypeConst.ID),
          name: _ctx.getPropertyValue(_ctx.HtmlTypeConst.NAME)
        }, null, 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createTextVNode(" " + _toDisplayString(_ctx.getPropertyValue(_ctx.HtmlTypeConst.TEXT)) + " ", 1 /* TEXT */),
    _hoisted_2
  ], 64 /* STABLE_FRAGMENT */))
}